module.exports = __webpack_public_path__ + "static/pr-op-packing-6707d0e11eb975ee0239cc24b486a481.png";